import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared.module';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { AppPreloader } from 'src/app/app-routing-loader';
import { AuthGuard } from 'src/app/components/cleanui/system/Guard/auth.guard';

// layouts & notfound
import { LayoutAuthComponent } from 'src/app/layouts/Auth/auth.component';
import { LayoutMainComponent } from 'src/app/layouts/Main/main.component';
import { participantPages } from './pages/participant/participants.routes';
import { userPages } from './pages/user/user.routes';
import { projectPages } from './pages/project/projects.routes';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full'
	},
	{
		path: '',
		component: LayoutMainComponent,
		children: [
			{
				path: 'dashboard',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('src/app/pages/dashboard/dashboard.module').then(
						m => m.DashboardModule
					)
			},
			{
				path: 'io',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('src/app/pages/io/io.module').then(m => m.IOModule)
			},
			{
				path: userPages.root.url,
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('src/app/pages/user/user.module').then(m => m.UserModule),
				data: {
					permissions: ['users:read', 'project-users:read'],
				},
			},
			{
				path: participantPages.root.url,
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('src/app/pages/participant/participants.module').then(m => m.ParticipantsModule),
				data: {
					permissions: ['participants:read'],
				},
			},
			{
				path: projectPages.root.url,
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('src/app/pages/project/projects.module').then(m => m.ProjectsModule),
				data: {
					permissions: ['projects:read'],
				},
			},
			{
				path: 'ui-showcase',
				canActivate: [AuthGuard],
				loadChildren: () =>
					import('src/app/pages/ui-showcase/ui-showcase.module').then(
						m => m.UiShowcaseModule
					)
			},
			{
				path: 'profile',
				canActivate: [AuthGuard],
				loadChildren: () => import('src/app/pages/profile/profile.module').then(m => m.ProfileModule)
			}
		]
	},
	{
		path: 'auth',
		component: LayoutAuthComponent,
		children: [
			{
				path: '',
				loadChildren: () =>
					import('src/app/pages/auth/auth.module').then(m => m.AuthModule)
			}
		]
	},
	{
		path: '**',
		redirectTo: '/auth/404'
	}
];

@NgModule({
	imports: [
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forRoot(routes, {
			useHash: true,
			preloadingStrategy: AppPreloader,
			//enableTracing: true
		}),
		LayoutsModule
	],
	providers: [AppPreloader],
	exports: [RouterModule]
})
export class AppRoutingModule {}
